import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetRouteTrajectoryQuery } from '../services/routes.service';
import type { TrajectoryPoint } from '../models';

interface UseRouteTrajectoryProps {
  routeId: string;
  skip?: boolean;
}

const EMPTY_TRAJECTORY: TrajectoryPoint[] = [];

const useRouteTrajectory = ({
  routeId,
  skip,
}: UseRouteTrajectoryProps) => {
  const { data, isLoading, error } = useGetRouteTrajectoryQuery(
    skip || !routeId
      ? skipToken
      : {
          routeId,
        },
    { refetchOnMountOrArgChange: true }
  );

  const trajectory = useMemo(
    () => data?.trajectory ?? EMPTY_TRAJECTORY,
    [data?.trajectory]
  );

  return {
    isLoading,
    error,
    trajectory,
  };
};

export default useRouteTrajectory;

